<template>
	<div>
		<el-collapse v-model="activeNames">
			<el-collapse-item name="1" v-loading="loading" element-loading-text="模板加载中">
				<template slot="title">
					<h2>1. 基础信息</h2>
				</template>
				<el-divider></el-divider>
				<el-form ref="form" :rules="rules" :model="form" label-width="80px">
					<el-form-item label="所属平台:">
						<el-radio-group v-model="form.platform" @change="platformChange">
							<el-radio :label="item.id.toString()" v-for="item in platform_list" border>{{item.name}}
							</el-radio>
							<!-- <el-radio label="1" border>Lazada</el-radio> -->
							<!-- <el-radio label="2" border>Shopee</el-radio> -->
						</el-radio-group>
					</el-form-item>
					<el-form-item label="国家地区:">
						<el-radio-group v-model="form.country" @change="countryChange">
							<el-radio v-bind:disabled="item.state==0" :label="item.id.toString()"
								v-for="item in country_list" border>{{item.name}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="所属店铺:">
						<el-select v-model="form.shop_id" placeholder="请选择">
							<el-option v-for="item in store_list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-link type="primary" @click="bindStore" style="margin-left: 20px;">绑定店铺</el-link>
					</el-form-item>
					<el-form-item label="商品链接" prop="goods_links">
						<el-input style="width: 50%;" v-model="form.goods_links" placeholder="链接必须加http或https协议">
						</el-input>
					</el-form-item>
					<el-form-item label="商品名称" prop="goods_name">
						<el-input style="width: 50%;" v-model="form.goods_name"></el-input>
					</el-form-item>
					<el-form-item label="商品主图" prop="goods_img">
						<el-col :span="12">
							<Img @imgList="imgsImg" :img_num="1" :img_edit="form.goods_img"></Img>
						</el-col>
					</el-form-item>
					<el-form-item label="SKU规格" prop="goods_sku">
						<el-input style="width: 30%;" v-model="form.goods_sku"></el-input>
					</el-form-item>
					<el-form-item label="商品单价" prop="goods_price">
						<el-input-number v-model="form.goods_price" :precision="2" :step="1" :min="0.00"
							@change="goodsPriceChange">
						</el-input-number>
						<span>{{coin_name}}</span>
						<span>（￥{{form.goods_price_rmb}}）</span>
						<span style="color: red;">提示: 按选择国家货币填写售价 系统自动换算</span>
					</el-form-item>
					<el-form-item label="每单数量" prop="goods_num">
						<el-input-number v-model="form.goods_num" :step="1" :min="1" @change="goodsNumChange">
						</el-input-number>个
						<span v-if="form.goods_num > over_goods_num_money.num"
							style="color: red;margin-left:20px;">超过{{over_goods_num_money.num}}件，每增加1件收取{{over_goods_num_money.money}}元超量服务费</span>
					</el-form-item>
					<el-form-item label="任务数量" prop="task_num">
						<el-input-number v-model="form.task_num" :step="1" :min="1" @change="taskNumChange">
						</el-input-number>
						<span style="color: red;margin-left:20px;">该款式今日要放单的总单数</span>
					</el-form-item>
					<el-form-item label="是否包邮:">
						<el-radio-group v-model="form.is_fs" @change="isFsChange">
							<el-radio label="0" border>不包邮</el-radio>
							<el-radio label="1" border>包邮</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">注：不包邮的任务，系统将预扣除 {{task_money_sign}}
							{{show_fs_money}}/单 邮费</span>
						<!-- <span style="color: red;margin-left:20px;">注：不包邮的任务，系统将预扣除 7元/单 邮费,发货时多退少补</span> -->
					</el-form-item>
					<el-form-item label="发布时间" prop="public_time">
						<div class="block">
							<el-date-picker v-model="form.public_time" align="right" type="date" placeholder="选择日期"
								:picker-options="pickerOptions">
							</el-date-picker>
							<span style="color: red;margin-left:20px;">提示：请选择今天以后的时间</span>
						</div>
					</el-form-item>
				</el-form>
			</el-collapse-item>
			<el-collapse-item name="2">
				<template slot="title">
					<h2>2. 进店方式</h2>
				</template>
				<el-divider></el-divider>
				<el-form :rules="rules" :model="form" label-width="80px">
					<el-form-item label="进店方式:">
						<el-radio-group v-model="form.in_shop_way" @change="inShopWayChange">
							<!-- <el-radio label="1" border>搜索关键词</el-radio> -->
							<!-- <el-radio label="2" border>其他渠道</el-radio> -->
							<el-radio :label="item.id.toString()" v-for="item in in_store" border>{{item.name}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-card v-show="in_1_show" class="box-card">
						<el-form-item class="is-required" v-for="(item,index) in form.in_keyword_data"
							:label="'关键词'+(Number(index)+Number(1))+':'">
							<el-input v-model="item.keyword" style="width: 20%;" placeholder="关键词"></el-input>
							<el-select v-model="item.sort" placeholder="请选择" style="margin-left: 10px;">
								<el-option label="选择排序方式" value=""></el-option>
								<el-option v-for="item in in_sort" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<el-input v-model="item.desc" style="width: 20%;margin-left: 30px;"
								placeholder="说明关键词的排序方式和页数"></el-input>
							<el-input v-model="item.num" style="width: 5%;margin-left: 10px;" placeholder="数量">
							</el-input>
							<el-button v-if="index == 0" style="margin-left: 20px;" @click="addInKeywordData">添加
							</el-button>
							<el-button v-else style="margin-left: 20px;" @click="removeInKeywordData(item)">删除
							</el-button>
						</el-form-item>
					</el-card>
					<el-card v-show="in_2_show" class="box-card">
						<el-row>
							<el-col :offset="3" :span="20">
								<div class="grid-content bg-purple-dark" style="color:red">注：其他渠道方式可以适用但不仅限于 淘宝直播、聚划算活动等
								</div>
							</el-col>
						</el-row>
						<el-row>
							<el-col :offset="3" :span="20">
								<div class="grid-content bg-purple-dark" style="color:red">
									添加搜索商品步骤图片（如有需要可上传搜索步骤帮助找商品，最多可上传5张图）</div>
							</el-col>
						</el-row>
						<el-form-item label="">
							<el-col :offset="2" :span="22">
								<Img @imgList="imgsImg2" :img_num="5" :img_edit="form.in_other_data.imgs"></Img>
							</el-col>
						</el-form-item>
						<el-form-item label="活动形式">
							<el-col :offset="2" :span="10">
								<el-input rows="4" placeholder="重要！商家必须清楚描述任务商品查找的入口步骤，可配合添加步骤图片" type="textarea"
									v-model="form.in_other_data.desc"></el-input>
							</el-col>
						</el-form-item>
						<el-form-item label="到期时间">
							<el-col :offset="2" :span="12">
								<div class="block">
									<el-date-picker v-model="form.in_other_data.end_time" align="right" type="date"
										placeholder="选择日期" :picker-options="pickerOptions">
									</el-date-picker>
									<span style="color: red;margin-left:20px;">提示：到期后系统会自动取消任务，存在几分钟延时属正常现象</span>
								</div>
							</el-col>

						</el-form-item>
					</el-card>
				</el-form>
			</el-collapse-item>
			<el-collapse-item name="3">
				<template slot="title">
					<h2>3. 千人千面</h2>
				</template>
				<el-divider></el-divider>
				<el-form :rules="rules" :model="form" label-width="120px">
					<el-form-item label="店铺Follow关注:">
						<el-radio-group v-model="form.is_follow" @change="isCommonChange($event,'is_follow')">
							<el-radio label="0" border>不需要</el-radio>
							<el-radio label="1" border>需要</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">要求此项 增值费 + {{s_cost_money.is_follow}} 元/单</span>
					</el-form-item>
					<el-form-item label="产品心愿单:">
						<el-radio-group v-model="form.is_wish" @change="isCommonChange($event,'is_wish')">
							<el-radio label="0" border>不需要</el-radio>
							<el-radio label="1" border>需要</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">要求此项 增值费 + {{s_cost_money.is_wish}} 元/单</span>
					</el-form-item>
					<el-form-item label="要求加入购物车:">
						<el-radio-group v-model="form.is_car" @change="isCommonChange($event,'is_car')">
							<el-radio label="0" border>不需要</el-radio>
							<el-radio label="1" border>需要</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">要求此项 增值费 + {{s_cost_money.is_car}} 元/单</span>
					</el-form-item>
					<el-form-item label="Chat在线聊天:">
						<el-radio-group v-model="form.is_chat" @change="isCommonChange($event,'is_chat')">
							<el-radio label="0" border>不需要</el-radio>
							<el-radio label="1" border>需要</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">要求此项 增值费 + {{s_cost_money.is_chat}} 元/单</span>
					</el-form-item>
				</el-form>
			</el-collapse-item>
			<el-collapse-item name="4">
				<template slot="title">
					<h2>4. 增值服务</h2>
				</template>
				<el-divider></el-divider>
				<el-form :rules="rules" :model="form" label-width="120px">
					<el-form-item label="货比数量:">
						<el-radio-group v-model="form.hb_num" @change="isCommonChange($event,'is_hb')">
							<el-radio :label="item.value.toString()" v-for="item in hb_num_set" border>{{item.label}}
							</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">要求此项 增值费 + {{s_cost_money.is_hb}} 元/单</span>
					</el-form-item>
					<el-form-item label="浏览商品数量:">
						<el-radio-group v-model="form.look_num" @change="isCommonChange($event,'is_look')">
							<el-radio :label="item.value.toString()" v-for="item in look_num_set" border>{{item.label}}
							</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">要求此项 增值费 + {{s_cost_money.is_look}} 元/单</span>
					</el-form-item>
					<el-form-item label="搭配商品:">
						<el-radio-group v-model="form.is_collocation" @change="collocationChange">
							<el-radio label="0" border>不启用</el-radio>
							<el-radio label="1" border>启用</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">有开启的，建议不要搭配太多附加商品 （启用此项将收取
							{{s_cost_money.is_collocation}} 元/个 增值费）</span>
					</el-form-item>
					<el-card v-show="collocation_data_show" class="box-card">
						<el-form-item class="is-required" v-for="(item,index) in form.collocation"
							:label="'链接'+(Number(index)+Number(1))+':'">
							<el-input v-model="item.links" style="width: 20%;" placeholder="请输入商品链接,必须加http或https协议">
							</el-input>
							<el-input v-model="item.title" style="width: 20%;margin-left: 10px;" placeholder="请输入商品标题">
							</el-input>
							<el-input v-model="item.sku" style="width: 20%;margin-left: 10px;" placeholder="请输入商品SKU">
							</el-input>
							<span style="margin-left: 10px;">商品价格：</span>
							<el-input-number v-model="item.price" :precision="2" :step="0.01" :min="0.00"
								@change="cPriceChange($event,index)">
							</el-input-number>
							<span>{{coin_name}}</span>
							<span>（￥{{item.price_rmb}}）</span>
							<el-button v-if="index == 0" style="margin-left: 20px;" @click="addCollocationData">添加
							</el-button>
							<el-button v-else style="margin-left: 20px;" @click="removeCollocationData(item)">删除
							</el-button>
							<el-col :span="22">
								<Img @imgList="imgsImg3" :index="index" :img_num="1" :img_edit="item.imgs"></Img>
							</el-col>
						</el-form-item>
					</el-card>
					<el-form-item label="优惠券:">
						<el-radio-group v-model="form.is_coupon" @change="couponChange">
							<el-radio label="0" border>不启用</el-radio>
							<el-radio label="1" border>启用</el-radio>
						</el-radio-group>
						<span style="color: red;margin-left:20px;">注：启用此项将收取 {{s_cost_money.is_coupon}} 元/个 增值费</span>
					</el-form-item>
					<el-card v-show="coupon_show" class="box-card">
						<el-form-item label="链接">
							<el-input v-model="form.coupon_links" style="width: 50%;"
								placeholder="请输入优惠券链接,必须加http或https协议"></el-input>
						</el-form-item>
					</el-card>
				</el-form>
			</el-collapse-item>
			<el-collapse-item name="5">
				<template slot="title">
					<h2>5. 其他</h2>
				</template>
				<el-divider></el-divider>
				<el-form :rules="rules" :model="form" label-width="80px">
					<el-form-item label="追加红包:">
						<el-input-number v-model="form.lucky_money" :precision="2" :step="1" :min="0.00"
							@change="lmChange">
						</el-input-number>
						<span style="color: red;margin-left:20px;">每单追加任务更快速</span>
					</el-form-item>
					<el-form-item label="模板名称:">
						<el-input style="width: 30%;" v-model="form.template_name"></el-input>
						<span style="color: red;margin-left:20px;">提示: 不填写名称则默认不创建模版</span>
					</el-form-item>
					<el-form-item label="留言提醒:">
						<el-input style="width: 50%;" v-model="form.message"></el-input>
					</el-form-item>
				</el-form>
			</el-collapse-item>
		</el-collapse>
		<el-row style="margin-top: 20px;color:red;">
			<el-col :span="24">
				<div class="grid-content bg-purple-dark">订单预估不包含运费，如产生运费以实际账单扣费为准</div>
			</el-col>
		</el-row>
		<el-row style="margin-top: 20px;text-align: center;">
			<el-col :span="24">
				<div class="grid-content bg-purple-dark">
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="tj">提交</el-button>
					<el-button @click="reset">重置</el-button>
				</div>
			</el-col>
		</el-row>
		<!-- 右下角信息框 -->
		<div class="el-notification right" style="bottom: 16px; z-index: 3000;">
			<div class="el-notification__group" style="margin-left: 60px;">
				<h2 class="el-notification__title"><i class="el-icon-coin" style="color: rgb(64, 158, 255);"></i>
					任务费用预算&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h2>
				<div class="el-notification__content" style="margin-top: 20px;text-align: center;">
					<p>商品单价：
						<span style="color:#409EFF;">
							{{task_money_sign}}
							<span v-show="this.form.currency_type == 0">{{total.goods_price}} </span>
							<span v-show="this.form.currency_type != 0">{{total_goods_price_out}}</span>
						</span>
					</p>
					<p>基础服务费：<span style="color:#409EFF;">¥ {{total.base_cost}}</span></p>
					<p>增值服务费：<span style="color:#409EFF;">¥ {{total.s_cost}}</span></p>
					<p v-if="over_goods_num_money_val > 0">超量服务费：<span style="color:#409EFF;">¥
							{{over_goods_num_money_val}}</span></p>
					<p>追加红包：<span style="color:#409EFF;">¥ {{total.lucky_money}}</span></p>
					<p>预扣邮费：
						<span style="color:#409EFF;">
							{{task_money_sign}}
							<span v-show="this.form.currency_type == 0">{{total.fs_money}}</span>
							<span v-show="this.form.currency_type != 0">{{total.fs_money_out}}</span>
						</span>
					</p>
					<el-divider></el-divider>
					<p><span style="color:#409EFF;margin-right: 20px;">x</span>任务数量：<span
							style="color:#409EFF;">{{form.task_num}}</span></p>
					<el-row v-show="this.form.currency_type == 0">
						<el-col :span="24">
							<div
								style="background-color: #409EFF;color:white;padding:6px;margin-top: 10px;border-radius: 4px;">
								合计：{{total.total}}</div>
						</el-col>
					</el-row>
					<el-row v-show="this.form.currency_type != 0">
						<el-col :span="24">
							<div
								style="background-color: #409EFF;color:white;padding:6px;margin-top: 10px;border-radius: 4px;">
								<span>本金合计：{{task_money_sign}} {{total_b_money_out}}</span><br>
								<span>佣金合计：¥ {{total_y_money_out}}</span>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="el-notification__closeBtn"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	import {
		costList,
		baseCostList,
		taskAdd,
		tmplDetails
	} from '@/api/jd_task'
	import Img from '@/components/Jd/img.vue' // 上传图片组件
	export default {
		components: {
			Img,
		},
		data() {
			return {
				loading: false,
				store_list: [],
				hb_num_set: [],
				look_num_set: [],
				// 基础信息
				platform_list: [],
				country_list: [],
				// 基础服务费
				baseCostList: [],
				// 增值服务费
				s_cost_list: [],
				in_store: [],
				// 金额单位
				coin_name: '',
				// 汇率
				exchange_rate: 0.00,
				activeNames: ['1', '2', '3', '4', '5'],
				// activeNames: ['4'],
				in_sort: [],
				in_1_show: true,
				in_2_show: false,
				collocation_data_show: false,
				coupon_show: false,
				form: {
					platform: "1",
					country: "2",
					shop_id: "",
					goods_links: "",
					goods_name: "",
					goods_img: '',
					goods_sku: "默认SKU",
					goods_price: 0.00,
					goods_price_rmb: '0.00',
					goods_num: 1,
					task_num: 1,
					is_fs: "0",
					public_time: '',
					in_shop_way: "1",
					in_keyword_data: [{
						'keyword': '',
						'sort': '',
						'desc': '',
						'num': '',
					}, ],
					in_other_data: {
						'imgs': '',
						'desc': '',
						'end_time': '',
					},
					is_follow: "0",
					is_wish: "0",
					is_car: "0",
					is_chat: "0",
					hb_num: "0",
					look_num: "0",
					is_collocation: "0",
					collocation: [{
						'links': '',
						'title': '',
						'sku':'',
						'price': '0.00',
						'price_rmb': '0.00',
						'imgs': '',
					}],
					is_coupon: "0",
					coupon_links: '',
					lucky_money: 0.00,
					template_name: "",
					message: "",
					currency_type: 0,
				},
				// 增值服务价格
				s_cost_money: {
					'is_follow': '0',
					'is_wish': '0',
					'is_car': '0',
					'is_chat': '0',
					'is_hb': '0',
					'is_look': '0',
					'is_collocation': '0',
					'is_coupon': '0',
				},
				total: {
					'goods_price_out': '',
					'goods_price': '0.00',
					'base_cost': '0.00',
					's_cost': '0.00',
					'lucky_money': '0.00',
					'fs_money_out': '',
					'fs_money': '0.00',
					'total': '0.00',
					'total_b_money_out': '',
					'total_y_money_out': '',
					'over_goods_num_money_val': '',
				},
				rules: {
					goods_links: [{
						required: true,
						message: '请输入商品链接',
						trigger: 'blur'
					}, ],
					goods_name: [{
						required: true,
						message: '请输入商品名称',
						trigger: 'blur'
					}, ],
					goods_img: [{
						required: true,
						message: '请选择商品主图',
						trigger: 'blur'
					}, ],
					goods_sku: [{
						required: false,
						message: '请输入商品SKU',
						trigger: 'blur'
					}, ],
					goods_price: [{
						required: true,
						message: '请输入商品单价',
						trigger: 'blur'
					}, ],
					goods_num: [{
						required: true,
						message: '请输入每单数量',
						trigger: 'blur'
					}, ],
					task_num: [{
						required: true,
						message: '请输入任务数量',
						trigger: 'blur'
					}, ],
				},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now();
					},
					shortcuts: [{
						text: '明天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '后天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
							picker.$emit('pick', date);
						}
					}]
				},
				// 支持支付的币种
				ct: {},
				// 预扣邮费配置
				ykyf: {},
				show_fs_money: '0.00',
				// 超量服务费配置
				over_goods_num_money: {},
				// 基础服务费，商家特供版
				tbcs_shop: [],
			};
		},
		// 计算属性
		computed: {
			// 货币符号
			task_money_sign: function() {
				switch (this.form.currency_type) {
					case 0:
						return '¥';
						break;
					case 1:
						return '฿';
						break;
					case 2:
						return '₱';
						break;
				}
			},
			// 右下角商品单价的数值（外币）
			total_goods_price_out: function() {
				// 乘以每单数量等于右下角的商品单价
				let money = (this.form.goods_price * this.form.goods_num).toFixed(2);

				// 搭配商品的价格
				let c_money = 0;
				this.form.collocation.forEach((item, index) => {
					if (!(item.price)) {
						item.price = '0.00';
					}
					c_money = parseFloat(c_money) + parseFloat(item.price);
				});

				// 还要加上搭配商品的价格（如果有开启搭配的话）
				if (this.form.is_collocation == 1) {
					let f_money = (parseFloat(money) + parseFloat(c_money)).toFixed(2);
					return f_money;
				}
				return money;
			},
			// 右下角本金合计（外币）
			total_b_money_out: function() {
				// (商品单价 + 邮费) * 任务数量
				let money = ((parseFloat(this.total_goods_price_out) + parseFloat(this.total.fs_money_out)) * this.form
					.task_num).toFixed(2);
				return money;
			},
			// 右下角佣金合计（人民币）
			total_y_money_out: function() {
				// (基础服务费 + 增值服务费 + 追加红包 + 超量服务费) * 任务数量
				let money = ((parseFloat(this.total.base_cost) + parseFloat(this.total.s_cost) + parseFloat(this.total
					.lucky_money) + parseFloat(this.over_goods_num_money_val)) * this.form.task_num).toFixed(2);
				return money;
			},
			// 超量服务费
			over_goods_num_money_val: function() {
				let money = (this.form.goods_num - this.over_goods_num_money.num) * this.over_goods_num_money.money;
				money = (money > 0 ? money : 0).toFixed(2)
				return money;
			}
		},
		async created() {
			this.getCost();
			this.getBaseCost();

			// 如果是从模板过来的，获取模板
			let tid = this.$route.query.tid;
			if (tid) {
				this.loading = true;
				await this.jiazai(tid);
			} else {
				let day3 = new Date();
				day3.setTime(day3.getTime() + 24 * 60 * 60 * 1000); // 明天的时间
				let time_str = day3.getFullYear() + "-" + (day3.getMonth() + 1) + "-" + day3.getDate();
				this.form.public_time = time_str;
			}
		},
		methods: {
			jiazai(tid) { // 加载模板数据
				tmplDetails(Qs.stringify({
					'id': tid
				})).then(response => {
					let r = response.result;
					if (r.form) {
						this.form = r.form;
						this.total = r.total;
						// // this.platformChange();//平台切换
						this.countryChange(this.form.country); //国家切换
						this.loading = false;
					}
				})
			},
			bindStore() {
				//路由跳转
				this.$router.push({
					path: '/user/store',
				});
			},
			imgsImg(e) { // 用户图片调用组件时候的回调
				this.form.goods_img = e;
			},
			imgsImg2(e) {
				this.form.in_other_data.imgs = e;
			},
			imgsImg3(e, index) {
				this.form.collocation[index].imgs = e;
			},
			addInKeywordData() {
				this.form.in_keyword_data.push({
					'keyword': '',
					'sort': '',
					'desc': '',
					'num': '',
				});
			},
			addCollocationData() {
				if (this.form.collocation.length >= 2) {
					this.$message({
						showClose: true,
						message: '最多2个搭配商品',
						type: 'error'
					});
					return false;
				}
				this.form.collocation.push({
					'links': '',
					'title': '',
					'price': '0.00',
					'price_rmb': '0.00',
					'imgs': []
				});
				this.sCollocation('add', 1);
			},
			removeInKeywordData(item) {
				var index = this.form.in_keyword_data.indexOf(item);
				if (index !== -1) {
					this.form.in_keyword_data.splice(index, 1)
				}
			},
			removeCollocationData(item) {
				var index = this.form.collocation.indexOf(item);
				if (index !== -1) {
					this.form.collocation.splice(index, 1)
					this.sCollocation('dec', 1);
				}
			},
			/************************ change事件 - 开始 ***************************/
			inShopWayChange(val) {
				if (val == 1) {
					this.in_1_show = true;
					this.in_2_show = false;
				} else {
					this.in_1_show = false;
					this.in_2_show = true;
				}
			},
			collocationChange(val) {
				this.collocation_data_show = val == 1 ? true : false;
				if (val == 1) {
					this.sCollocation('add', this.form.collocation.length);
				} else {
					this.sCollocation('dec', this.form.collocation.length);
				}
				this.compute1();
			},
			couponChange(val) {
				this.coupon_show = val == 1 ? true : false;
				this.isCommonChange(val, 'is_coupon');
			},
			// 平台变化的时候
			platformChange() {
				this.getBaseCost()
				// this.compute1();
			},
			// 国家变化的时候
			countryChange(val) {
				this.getCx(val);
				this.getBaseCost()
				// this.compute1();
			},
			// 商品单价改变事件
			goodsPriceChange(val) {
				if (!val) {
					this.form.goods_price = '0.00';
				}
				this.compute1();
			},
			// 每单数量改变事件
			goodsNumChange(val) {
				if (!val) {
					this.form.goods_num = '1';
				}
				this.compute1();
			},
			isFsChange(val) {
				// let fs_money = val == 1 ? '0.00' : '7.00';
				// this.total.fs_money = fs_money;
				this.compute1();
			},
			// 千人千面等公共事件
			isCommonChange(val, val2) {
				// 获取费用
				let money = this.s_cost_money[val2];

				if (val == 1) {
					var s_cost = parseFloat(this.total.s_cost) + parseFloat(money);
				} else {
					var s_cost = this.total.s_cost - money;
				}
				this.total.s_cost = s_cost.toFixed(2);
				this.compute1();
			},
			// 搭配商品增值费计算
			sCollocation(ac = 'add', num = 1) {
				// 获取费用
				let money = this.s_cost_money.is_collocation;
				money = money * num;

				if (ac == 'add') {
					var s_cost = parseFloat(this.total.s_cost) + parseFloat(money);
				} else {
					var s_cost = this.total.s_cost - money;
				}
				this.total.s_cost = s_cost.toFixed(2);
			},
			// 搭配商品价格变化
			cPriceChange(val, index) {
				this.compute1();
			},
			// 追加红包变化
			lmChange(val) {
				if (!val) {
					this.form.lucky_money = 0.00;
				}
				this.total.lucky_money = this.form.lucky_money.toFixed(2);
				this.compute1();
			},
			// 任务数量变化
			taskNumChange(val) {
				if (!val) {
					this.form.task_num = '1';
				}
				this.compute1();
			},
			/************************ change事件 - 结束 ***************************/

			// 遍历国家，获取币名和汇率
			getCx(val = '') {
				if (val == '') {
					this.coin_name = this.country_list[0].coin_name;
					this.exchange_rate = this.country_list[0].exchange_rate;
				} else {
					this.country_list.forEach(item => {
						if (val == item.id) {
							this.coin_name = item.coin_name;
							this.exchange_rate = item.exchange_rate;
							return false;
						}
					})
				}
			},
			/************************ 请求接口 - 开始 ***************************/
			// 获取收费标准
			getCost() {
				costList().then(response => {
					let r = response.result;
					this.country_list = r.country;
					this.platform_list = r.platform;
					this.s_cost_list = r.sCost;
					this.store_list = r.store_list;

					// 进店方式配置
					this.in_store = r.in_store;
					this.form.in_shop_way = this.in_store[0].id.toString();
					this.inShopWayChange(this.form.in_shop_way);

					this.in_sort = r.in_sort;
					this.hb_num_set = r.hb_num_set;
					this.look_num_set = r.look_num_set;

					// 配置增值服务的费用
					this.s_cost_list.forEach(item => {
						switch (item.key) {
							case 'is_follow':
								this.s_cost_money.is_follow = item.price;
								break;
							case 'is_wish':
								this.s_cost_money.is_wish = item.price;
								break;
							case 'is_car':
								this.s_cost_money.is_car = item.price;
								break;
							case 'is_chat':
								this.s_cost_money.is_chat = item.price;
								break;
							case 'is_hb':
								this.s_cost_money.is_hb = item.price;
								break;
							case 'is_look':
								this.s_cost_money.is_look = item.price;
								break;
							case 'is_collocation':
								this.s_cost_money.is_collocation = item.price;
								break;
							case 'is_coupon':
								this.s_cost_money.is_coupon = item.price;
								break;
						}
					});

					// 获取默认的币名和汇率
					this.getCx();

					// 支持支付的币种
					this.ct = r.ct;

					// 预扣邮费配置
					this.ykyf = r.ykyf;

					// 超量服务费配置
					this.over_goods_num_money = r.over_goods_num_money;

					// 基础服务费 - 商家特供版
					this.tbcs_shop = r.tbcs;

					this.compute1();
				})
			},
			// 获取基础服务费
			getBaseCost() {
				let post = {
					'platform_id': this.form.platform,
					'country_id': this.form.country,
				}
				baseCostList(Qs.stringify(post)).then(response => {
					this.baseCostList = response.result;
					this.compute1();
				})
			},
			/************************ 请求接口 - 结束 ***************************/

			/******************* 计算 - 开始 **************************/
			compute1() {
				// 判断是否支持外币支付
				let ykyf = this.ykyf; //获取到的所有预扣邮费
				if (this.form.country == 7 && this.ct.is_show_th) {
					// 泰国
					this.form.currency_type = 1;
					this.show_fs_money = ykyf.th;
					this.total.fs_money = this.form.is_fs == 0 ? ykyf.rmb : '0.00';
					this.total.fs_money_out = this.form.is_fs == 0 ? ykyf.th : '0.00';
				} else if (this.form.country == 2 && this.ct.is_show_ph) {
					// 菲律宾
					this.form.currency_type = 2;
					this.show_fs_money = ykyf.ph;
					this.total.fs_money = this.form.is_fs == 0 ? ykyf.rmb : '0.00';
					this.total.fs_money_out = this.form.is_fs == 0 ? ykyf.ph : '0.00';
				} else {
					// 中国
					this.form.currency_type = 0;
					this.show_fs_money = ykyf.rmb;
					this.total.fs_money = this.form.is_fs == 0 ? ykyf.rmb : '0.00';
					this.total.fs_money_out = '0.00';
				}

				// 商品单价除以汇率，保留两位小数
				let num = '0.00';
				if (this.exchange_rate != 0) { // 因为一开始汇率是0
					num = (this.form.goods_price / this.exchange_rate).toFixed(2);
				}
				this.form.goods_price_rmb = num; // 商品单价

				// 搭配商品的价格
				let num_c_total = 0; // 搭配商品的总价格
				this.form.collocation.forEach((item, index) => {
					if (!(item.price)) {
						item.price = '0.00';
					}

					let num_c = 0;
					if (this.exchange_rate != 0) {
						num_c = (item.price / this.exchange_rate).toFixed(2);
					}
					item.price_rmb = num_c;
					num_c_total = parseFloat(num_c_total) + parseFloat(num_c);
				});

				// 乘以每单数量等于右下角的商品单价
				let num2 = (num * this.form.goods_num).toFixed(2);

				// 还要加上搭配商品的价格（如果有开启搭配的话）
				if (this.form.is_collocation == 1) {
					num2 = parseFloat(num2) + parseFloat(num_c_total)
					num2 = num2.toFixed(2);
				}
				this.total.goods_price = num2;

				// 计算基础服务费应该多少
				this.total.base_cost = '0.00';
				if (num2 > 0) {
					let num3 = 1000; // 默认1000
					this.baseCostList.forEach(item => {
						if (num2 > item.min_money && num2 <= item.max_money) {
							num3 = item.seller_cost;
						}
					})

					// 如果商家有特殊的基础服务费，按照特殊基础服务费计算
					this.tbcs_shop.forEach((item) => {
						if (item.country_id == this.form.country) {
							num3 = parseFloat(item.money);
						}
					});

					this.total.base_cost = num3.toFixed(2);
				}

				// 计算合计（商品单价 + 基础服务费 + 增值服务费 + 追加红包 + 预扣邮费 + 超量服务费）
				let total = parseFloat(this.total.goods_price) + parseFloat(this.total.base_cost) +
					parseFloat(this.total.s_cost) + parseFloat(this.total.lucky_money) +
					parseFloat(this.total.fs_money) + parseFloat(this.over_goods_num_money_val);
				// 还要乘以任务数量
				total = (total * this.form.task_num).toFixed(2);
				this.total.total = total;

			},
			/******************* 计算 - 结束 **************************/
			// 重置
			reset() {
				this.$router.go(0);
			},
			// 提交
			tj() {
				this.$store.commit('setAjaxLoading', true);

				this.total.goods_price_out = this.total_goods_price_out;
				this.total.total_b_money_out = this.total_b_money_out;
				this.total.total_y_money_out = this.total_y_money_out;
				// 超量服务费
				this.total.over_goods_num_money_val = this.over_goods_num_money_val;

				let post = {
					'form': this.form,
					'total': this.total,
				}
				taskAdd(Qs.stringify(post)).then(response => {
					this.$message({
						showClose: true,
						message: '提交成功',
						type: 'success'
					});
					setTimeout(() => {
						//路由跳转
						this.$router.push({
							path: '/jd_task/list',
						});
					}, 1000);

				})
			},
		}
	}
</script>

<style>
	.el-collapse-item__header {
		color: #409EFF;
	}

	.el-radio {
		margin-right: 0px;
	}
</style>
